import React from 'react'
import PropTypes from 'prop-types'
import styles from './master-form.module.css'

export const Supplier = {
  BritishGas: 'britishGas',
  Npower: 'npower',
  Sse: 'sse',
  Edf: 'edf',
  Other: 'other',
}

export default class StepCurrentSupplier extends React.Component {
  render() {
    return (
      <>
        <p className={styles.question}>Who is your current supplier?</p>
        <div className={styles.formCheck}>
          <input
            type="radio"
            checked={this.props.supplier === Supplier.BritishGas}
            className={styles.formCheckInput}
            id={Supplier.BritishGas}
            name="supplier"
            value={Supplier.BritishGas}
            onChange={this.props.handleChange}
          />
          <label htmlFor={Supplier.BritishGas}>British Gas</label>
        </div>
        <div className={styles.formCheck}>
          <input
            type="radio"
            checked={this.props.supplier === Supplier.Npower}
            className={styles.formCheckInput}
            id={Supplier.Npower}
            name="supplier"
            value={Supplier.Npower}
            onChange={this.props.handleChange}
          />
          <label htmlFor={Supplier.Npower}>npower</label>
        </div>
        <div className={styles.formCheck}>
          <input
            type="radio"
            checked={this.props.supplier === Supplier.Sse}
            className={styles.formCheckInput}
            id={Supplier.Sse}
            name="supplier"
            value={Supplier.Sse}
            onChange={this.props.handleChange}
          />
          <label htmlFor={Supplier.Sse}>SSE</label>
        </div>
        <div className={styles.formCheck}>
          <input
            type="radio"
            checked={this.props.supplier === Supplier.Edf}
            className={styles.formCheckInput}
            id={Supplier.Edf}
            name="supplier"
            value={Supplier.Edf}
            onChange={this.props.handleChange}
          />
          <label htmlFor={Supplier.Edf}>EDF</label>
        </div>
        <div className={styles.formCheck}>
          <input
            type="radio"
            checked={this.props.supplier === Supplier.Other}
            className={styles.formCheckInput}
            id={Supplier.Other}
            name="supplier"
            value={Supplier.Other}
            onChange={this.props.handleChange}
          />
          <label htmlFor={Supplier.Other}>Other</label>
        </div>
      </>
    )
  }
}

StepCurrentSupplier.propTypes = {
  supplier: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
}
